import { useEffect, useState } from 'react'
import { postMessageToParent, requestHostViewportCenter } from '@utils/iframe'
import { isShopifyEmbed } from '@utils/embedConfig'

export function useCenterIframeOnOpen(isOpen: boolean): number | undefined {
  const [centerY, setCenterY] = useState<number | undefined>(undefined)

  useEffect(() => {
    // Shopify only: the host page owns the viewport, so ask it where the visible center is.
    if (!isOpen || !isShopifyEmbed()) {
      return
    }
    let cancelled = false
    requestHostViewportCenter().then(center => {
      if (cancelled) {
        return
      }
      if (center != null) {
        setCenterY(center)
      } else {
        postMessageToParent({ type: 'scrollIframeCenter' })
      }
    })
    return () => {
      cancelled = true
    }
  }, [isOpen])

  return isOpen ? centerY : undefined
}
